const age = (x) => Math.round(x / 365) || 1
/*
const birthDate = (x) => {
    let d = new Date()
    d.setDate(d.getDate() - x)
    return [d.getUTCFullYear(),d.getUTCMonth() + 1, d.getUTCDate()].join('/')
}
*/

function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

function decodeBase64(token) {
    var base64 = token.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export default {
    logins: (state, getters, rootState, rootGetters) => {
        let results = []
        try {
            if (rootGetters['v4/settings/get']('cdn')) {
                results = [{ name: 'Default', token: 'default' }]
            }
            let v = document.cookie.match('(^|;) ?' + 'token' + '=([^;]*)(;|$)');
            let key = v ? v[2] : null;
            let data = parseJwt(key)
            results = data.scopes.engagements.map(x => decodeBase64(x))
        }
        catch (e) {}
        return results
    },

    authenticated: (state, getters, rootState, rootGetters) => {
        if (rootGetters['v4/settings/get']('cdn')) {
            return true
        }
        const hasCookie = (name) => document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)') !== null
        return hasCookie('session') && hasCookie('token')
    },

    active: (state) => {
        return state.uuid
    },
    
    key: (state, getters, rootState, rootGetters) => {
        if (rootGetters['v4/settings/get']('cdn')) {
            return 'default'
        }
        let v = document.cookie.match('(^|;) ?' + 'session' + '=([^;]*)(;|$)');
        let key = v ? v[2] : null;
        return key ? decodeURIComponent(key) : key
    },
    experience: () => {
        let result = 'browser'
        try {
            if (window.matchMedia('(display-mode: standalone)').matches) {
                result = 'pwa'
            }
        }
        catch (e) {}
        return result
    },

    details: (state, getters, rootState, rootGetters) => (output = 'object') => {

        let obj = {}

        if (rootGetters['v4/mode/get']('triggerQueueingError')) {
            let test = obj.error.name
        }

        obj.id = { id: state.uuid }
        obj.encounter = {
            id: rootState.settings.id,
            name: rootState.settings.name,
            code: rootState.settings.code,
            token: rootState.settings.token,
            status: rootState.settings.status,
            region: rootState.settings.region,
            experience: getters.experience,
            env: rootGetters['v4/settings/get']('env'),
            deployment: rootGetters['v4/settings/get']('cdn') ? 'cdn' : 'heroku',
            language: rootState.v4.language.selected,
            network: 'ThinkMD'
        }

        let track = rootGetters['v4/track/current']
        obj.track = {
            id: track.id,
            name: track.name,
            trackSequence: rootState.v4.collect.sequences[track.name] || 1,
            globalSequence: rootState.v4.collect.globalSequence,
            streamlinedSelections: rootGetters['v4/track/streamlinedOptionsDataSave'],
            comprehensive: rootState.v4.track.comprehensive,
            thresholdSet: rootState.v4.track.thresholdSet,
        }

        rootGetters['v4/track/classifications'].forEach(classification => {
            obj.track[classification.name] = classification.value
        })

        let status = rootGetters['v4/mrx/status'].reduce((a, c) => {
            a[c.name] = c.value
            return a
        }, {})

        obj.status = Object.assign({}, status, {
            triage: rootGetters['v4/mrx/triage'],
            triage_selected: rootGetters['v4/mrx/triageSelected'](),
            assessments: rootGetters['v4/mrx/assessments']().length,
            treatments: rootGetters['v4/mrx/treatments']().length,
            plans: rootGetters['v4/mrx/plans']().length,
        })

        obj.patient = {
            uuid: state.patient_uuid,
            age: age(rootGetters['v4/panel/getResponse']('age', 'days').value),
            ageInDays: rootGetters['v4/panel/getResponse']('age', 'days').value,
            gender: rootGetters['v4/panel/checkResponse']('gender', 'male') ? 'male' : 'female',
            name: rootGetters['v4/panel/getResponse']('patient_name', 'name').value || null,
            patientId: rootGetters['v4/panel/getResponse']('patient_id', 'number').value || null,
            phoneNumber: rootGetters['v4/panel/getResponse']('patient_phone', 'number').value || null,
            birthDate: null // birthDate(rootGetters['v4/panel/getResponse']('age', 'days').value)
        }

        let userId = rootGetters['v4/preference/getResponse']('user_id', 'number').value
          || rootGetters['v4/panel/getResponse']('user_id', 'number').value
          || null
        
        obj.user = {
            id: userId,
            phoneNumber: null,
            type: rootGetters['v4/track/settings']('audience') === 'chw' ? 'professional' : 'consumer',
            registration_id: rootState.v4.registration.registrationId,
            hr_id: rootState.v4.registration.hrId,
        }

        let params = Object.assign({}, rootState.v4.settings.params)
        obj.partner = ['group', 'organization', 'country', 'region', 'area', 'site', 'user_id', 'session_id'].reduce((acc, partner) => {
            acc[partner] = params[partner] || null
            delete params[partner]
            return acc
        }, {})
        obj.partner.params = Object.entries(params).map(param => { return { name: param[0], value: param[1] } })

        if (rootState.v4.rdt.status !== 'none') {
            obj.rdt = JSON.parse(JSON.stringify(rootState.v4.rdt))
        }

        obj.timing = {
            start: state.start,
            end: new Date().toISOString(),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            when: rootGetters['v4/settings/get']('submitOnAssessment') ? 'assessment' : 'upload'
        }

        obj.enrichment = {
            user_agent: navigator.userAgent,
            ip_address: rootState.session.ip_address
        }
        
        obj.release = rootState.release

        if (output === 'array') {
            return Object.entries(obj).reduce((acc, cur) => {
                let key = cur[0]
                let item = cur[1]
                Object.entries(item).forEach(x =>
                    acc.push({ type: key, name: x[0], value: x[1] })
                )
                return acc
            }, [])
        }
        else {
            return obj
        }
    }
}
